// @systeme: contrat
// Forme unique des erreurs renvoyées par l'API. Le « message » est toujours écrit pour
// l'utilisatrice (voir docs/produit.md §7) ; le « code » sert au client pour réagir.
import { z } from 'zod';
export const SchemaErreurApi = z.object({
    code: z.string(),
    message: z.string(),
    details: z.record(z.string(), z.array(z.string())).optional(),
});
//# sourceMappingURL=erreurs.js.map